import { ref, onMounted, onUpdated } from "vue";

export default function useUpdatePWA() {

	const refreshing = ref(false);
	const registration = ref<ServiceWorkerRegistration | null>(null);
	const updateExists = ref(false);
	const isUpToDate = ref(true);

	// Fonction pour rafraîchir l'application
	const refreshApp = () => {

		updateExists.value = false;

		if (registration.value && registration.value.waiting) {
			registration.value.waiting.postMessage({ type: 'SKIP_WAITING' });
			registration.value.waiting.addEventListener('statechange', (e: Event) => {

				const target = e.target as ServiceWorker;
				if (target.state === 'activated') {
					window.location.reload();
				} else {
					window.location.reload();
				}
			});
		} else {
			window.location.reload();
		}
	};


	onMounted(() => {
		if (import.meta.env.DEV) return;

		if ('serviceWorker' in navigator) {

			// Au montage, la page est-elle déjà contrôlée par un service worker ?
			// - true  => visite normale : un changement de contrôleur signifiera qu'une
			//            NOUVELLE version vient d'être activée => on recharge pour éviter de
			//            rester sur d'anciens chunks supprimés (page blanche, Mantis 0028073).
			// - false => tout premier chargement (aucun SW) : le clientsClaim initial déclenche
			//            aussi 'controllerchange', mais SANS nouvelle version => on ne recharge pas.
			const hadController = !!navigator.serviceWorker.controller;

			navigator.serviceWorker.register('/service-worker.js').then(reg => {
				registration.value = reg;

				reg.onupdatefound = () => {

					const newWorker = reg.installing;
					if (newWorker) {
						newWorker.onstatechange = () => {
							if (newWorker.state === 'installed') {
								if (navigator.serviceWorker.controller) {
									updateExists.value = true;
									isUpToDate.value = false;
								} else {
									isUpToDate.value = true;
									updateExists.value = false;
								}
							}
						};
					}
				};
			}).catch(error => {
				console.error('Service worker registration failed:', error);
			});

			navigator.serviceWorker.addEventListener('controllerchange', () => {
				updateExists.value = true;
				isUpToDate.value = false;

				// Nouvelle version activée (le SW fait skipWaiting + clientsClaim) : on recharge
				// une seule fois pour récupérer l'index.html et les chunks à jour. On ignore le
				// tout premier clientsClaim (aucun contrôleur au montage) pour ne pas recharger
				// inutilement à la première visite.
				if (hadController && !refreshing.value) {
					refreshing.value = true;
					window.location.reload();
				}
			});
		}
	});

	return {
		refreshing,
		registration,
		updateExists,
		isUpToDate,
		refreshApp
	};
}